import { Injectable } from "@angular/core";

export class TransformAnimationService {
    private transitionDuration: number = 500;
    private element: HTMLElement;
    private inTransition: boolean;

    constructor(element: HTMLElement) {
        this.element = element;
        this.inTransition = false;
    }

    public getTransitionDuration(): number {
        return this.transitionDuration;
    }

    public updateTransition(duration: number) {
        this.transitionDuration = duration;
    }

    public clearTransition() {
        if (this.isCanvasVisible()) {
            this.element.style.transition = 'none';
        }
    }

    public startTransition() {
        if (this.isCanvasVisible()) {
            this.inTransition = true;
        }
    }

    public completeTransition() {
        this.inTransition = false;
    }

    public isInTransition() {
        return this.inTransition;
    }

    public applyTransition(property?: string, duration?: number, timingFunction: string = 'ease'): void {
        if (this.isCanvasVisible()) {
            if (!property) {
                this.element.style.transition = `${duration} ${timingFunction}`;
            } else if (duration) {
                // Apply default transition to all properties
                this.element.style.transition = `${property} ${duration}ms ${timingFunction}`;
            } else {
                this.element.style.transition = `${property} ${this.transitionDuration}ms ${timingFunction}`;
            }
        }
    }

    private isCanvasVisible = (): boolean => {
        return !!this.element?.clientWidth && !!this.element.clientHeight;
    }
}
